/**
 * Email Validation Utilities
 */

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

/**
 * Normalize email input
 * - Trim whitespace
 * - Convert to lowercase
 * 
 * @param {string} input - Raw input string
 * @returns {string} - Normalized email or empty string
 */
export function normalizeEmail(input) {
  if (!input || typeof input !== 'string') {
    return '';
  }
  
  return input.trim().toLowerCase();
}

/**
 * Check if input is a valid email address
 * 
 * @param {string} input - Email to validate
 * @returns {boolean} - True if valid email format
 */
export function isValidEmail(input) {
  if (!input || typeof input !== 'string') {
    return false;
  }
  
  const normalized = normalizeEmail(input);
  return EMAIL_REGEX.test(normalized);
}

/**
 * Get validation error message for email
 * 
 * @param {string} input - Email to validate
 * @param {boolean} required - Whether field is required (default: false)
 * @returns {string|null} - Error message or null if valid
 */
export function getEmailError(input, required = false) {
  // If not required and empty, it's valid
  if (!input || !input.trim()) {
    if (required) {
      return 'Email is required';
    }
    return null; // Not required and empty is valid
  }
  
  // If value is provided, validate it
  if (!isValidEmail(input)) {
    return 'Enter a valid email address';
  }
  
  return null; // Valid
}

